import { useContext } from 'react';
import SyncContext from '~/context/SyncContext';

export const useSyncContext = () => {
  const context = useContext(SyncContext);
  
  if (!context) {
    throw new Error('useSyncContext deve ser usado dentro de SyncProvider');
  }
  
  return context;
};